import React, { useState } from 'react'
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { useCheckoutContext } from '../../../context/checkout/CheckoutContext';
import { FormatCurrency } from '../../../utils/FormatCurrency'
import { Checkout } from '../../checkoutCart/components/Checkout';
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';
import CartLoader from '../../../components/CartLoader';
import Cookies from 'js-cookie';
import { trackProceedPay } from '../../../utils/FacebookPixel';
import { placeOrderCTA } from '../../../models/cartData';
import { addPaymentInfoEvent, addShippingInfoEvent, beginCheckoutEvent, pushCartItem } from '../../../utils/GoogleAnalytics';

// import placeOrderCTA from



interface dataProps {
  temp_cart_id: any;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  utm_content?:string;
  utm_term?:string;
  order_source: string;
  solution_delivery: boolean;
  address?:any

}

const PlaceOrderCTA = ({ total, cart_id, buttton_text, onPress, setOpenCheckout, addressFlag }: placeOrderCTA) => {
  const { pageData,getCartData, setPageData, handleClick, isClickData, handleModal, modalOpenData, openPopup, handleAddNewAddress, isCartLoadingData } = useShoppingCart();

  const data = getCartData;
  const tempCartItems:any = data?.data[0]?.temp_cart_items;
  const payment_type = data?.data[0].is_cod;

  let payment_mode = ''
  if(payment_type == 1){
    payment_mode = 'cod'
  }else{
    payment_mode = 'prepaid'
  }
 
  let cart_item_array:any = [];
  const cartItemsEvent = pushCartItem(tempCartItems, cart_item_array);
  
  




  // const [checkoutOpen, setCheckoutOpen] = useState(false);
  // console.log(cart_id, 'isClickData');

  let utmSource: any = "";
  let utmMedium : any= "";
  let utmCampaign: any = "";
  let utmContent: any = "";
  let utmTerm: any= "";


   utmSource = Cookies.get("utmSource");
   utmMedium = Cookies.get("utmMedium");
   utmCampaign = Cookies.get("utmCampaign");
   utmContent = Cookies.get("utmContent");
   utmTerm = Cookies.get("utmTerm");

  
  const handleClickCheckout = () => {
    openPopup('checkout');
  };


  const paylod: any = {
    "temp_cart_id": cart_id,
    "utm_source": utmSource,
    "utm_campaign": utmMedium,
    "utm_medium": utmCampaign,
    "utm_content":utmContent,
    "utm_term":utmTerm,
    "order_source": "checkout",
    "solution_delivery": true
  }

  return (
    <>
      <div className='placeOrder'>
        <div style={{ position: 'relative' }}>
          {isCartLoadingData && <CartLoader />}
         
          {/* <Nav.Link to="/checkout" as={ NavLink }>             */}

          {/* <button className='placeOrderCTA ripple' onClick={() => {onPress(cart_id); setOpenCheckout(true); setPageData(2);  }}> */}

          {/* <button className='placeOrderCTA ripple' onClick={() => { onPress(paylod); handleClickCheckout(); setPageData(2); }}> */}
          <button className='placeOrderCTA ripple'

            onClick={() => {
              if (addressFlag === true) {
                onPress(paylod);
                handleClickCheckout();
                setPageData(2);
                trackProceedPay();
                beginCheckoutEvent(cartItemsEvent);
                addShippingInfoEvent(cartItemsEvent);
                addPaymentInfoEvent(payment_mode,cartItemsEvent)
              } else {
                handleAddNewAddress()
              }
            }}
          >

          
            {addressFlag === true ? (Number(total) > 0 ? <span>Rs. {total}</span> : 'Rs. 0') : ''}

            {addressFlag === true ?  (total && buttton_text && <span className='separator'></span> ) : ''}
            
            <span>{buttton_text}</span>

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.4301 5.93005L20.5001 12.0001L14.4301 18.0701" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M3.5 12H20.33" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

          </button>
          {/* </Nav.Link> */}
        </div>
      </div>
      {/* {checkoutOpen && <Checkout />} */}
      {/* {checkoutOpen && <Checkout setOpenCheckput={checkoutOpen} />} */}

    </>

  )
}

export default PlaceOrderCTA
